// extracted by mini-css-extract-plugin
export default {"anim":"SlideFadeIn_anim__ikyEx","slideFadeIn":"SlideFadeIn_slideFadeIn__kfmqo","toBeAnimated":"SlideFadeIn_toBeAnimated__W3YMI"};